export function formatCurrency(value: string | number | null | undefined, minor = false): string {
  if (value == null) return "0 kr";
  const num = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(num)) return "0 kr";
  const amount = minor ? num / 100 : num;
  return `${amount.toLocaleString("nb-NO", { maximumFractionDigits: 0 })} kr`;
}

export function formatDate(dateStr: string | null | undefined): string {
  if (!dateStr) return "-";
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return "-";
  return d.toLocaleDateString("nb-NO", { day: "2-digit", month: "short", year: "numeric" });
}

export function timeAgo(dateStr: string | null | undefined): string {
  if (!dateStr) return "-";
  const now = Date.now();
  const then = new Date(dateStr).getTime();
  if (isNaN(then)) return "-";
  const diff = now - then;
  const minutes = Math.floor(diff / 60_000);
  if (minutes < 60) return `${minutes}m siden`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}t siden`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days}d siden`;
  const months = Math.floor(days / 30);
  return `${months}mnd siden`;
}

export function getTierLabel(tier: string | null | undefined): string {
  if (!tier) return "Ingen";
  const map: Record<string, string> = {
    monthly: "Manedlig",
    yearly: "Arlig",
    single: "Enkelt",
  };
  return map[tier] ?? tier;
}

export function getTierVariant(tier: string | null | undefined): "default" | "secondary" | "destructive" | "outline" {
  if (!tier) return "outline";
  if (tier === "yearly") return "default";
  if (tier === "monthly") return "secondary";
  return "outline";
}

export function toISODate(d: Date): string {
  return d.toISOString().slice(0, 10);
}

export const statusLabels: Record<string, string> = {
  paid: "Betalt",
  bloodTestRequested: "Trenger biomarkorforslag",
  pendingRequisition: "Venter rekvisisjon",
  requisitioned: "Rekvisisjon sendt",
  awaitingResults: "Venter resultater",
  allBiometricResultsReceived: "Resultater mottatt",
  assessmentCompleted: "Vurdering fullfort",
  requestRejected: "Avvist",
  selfReported: "Selvrapportert",
};

export function translateStatus(status: string): string {
  return statusLabels[status] ?? status;
}

export function formatMonth(monthStr: string): string {
  const months = ["jan", "feb", "mar", "apr", "mai", "jun", "jul", "aug", "sep", "okt", "nov", "des"];
  const [y, m] = monthStr.split("-");
  const idx = parseInt(m!, 10) - 1;
  const shortYear = y!.slice(2);
  return `${months[idx] ?? monthStr} ${shortYear}`;
}
